export const capitalize = str => {
  if (str === "") {
    return str;
  }
  const newStr = str.replace("_", " "); // also clean up _
  return `${newStr[0].toUpperCase()}${newStr.substr(1)}`;
};
